<template>
<div id='theme-body' style="height: 100%;">
  <theme-main-nav></theme-main-nav>
  <div class="row no-gutters" style="height: 100%;">
    <div class="col-md-2 independent-scroll">
      <theme-sidebar ref="sidebar" id="theme-sidebar" v-if="state.user"></theme-sidebar>
    </div>
    <div class="col-md-10" style="max-height: 100%; overflow-y: hidden">
      <div id='theme-content' style="height: 100%">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <theme-footer id='theme-footer'></theme-footer>
</div>
</template>

<script>
import Store from 'system/store'
export default {
  data(){
    return {
      state: Store.state
    }
  }
}
</script>

<style lang="css">
.independent-scroll{
  max-height: 100vh;
  overflow-y:scroll;
  padding-bottom: 10px;
}
</style>
